/*
 *  REX Element Loading plugin
 *  usage:
 *      . activate (true|false|NULL) - this will display the loader on the selected element
 *      . destroy (true|false|NULL) - this will remove the spinner from the DOM
 *      . id - apply an id attribute to the element so it can be easily identified at a later time
 */
$.fn.rexElementSpinner = function(options) {
	var $that = $(this);

	var settings = $.extend(
		{
			activate: false,
			destroy: false,
			id: null
		},
		options
	);

	$that.each(function(i, el) {
		var $el = $(el);

		if (settings.destroy) {
			$el
				.siblings(".element-overlay")
				.first()
				.remove();
			$el.removeClass("element-overlay-parent");
			return;
		}

		if (!$el.hasClass("element-overlay-parent")) {
			$el.addClass("element-overlay-parent");
		}

		var elementOverlay;
		if ($el.siblings(".element-overlay").length == 0) {
			elementOverlay = $(
				'<div class="element-overlay"><div class="k-loading-mask"><div class="k-loading-color"></div></div></div>'
			).insertAfter($el);
		} else {
			elementOverlay = $el.siblings(".element-overlay").first();
		}

		if (settings.id != null) {
			elementOverlay.attr("data-id", settings.id);
		}

		if (settings.activate && !elementOverlay.hasClass("active")) {
			elementOverlay.addClass("active").fadeIn("slow");
		} else {
			elementOverlay.removeClass("active");
		}
	});
};

/**
 * Adds REX formatting to a Bootstrap accordion.
 */
$.fn.rexProductToggleAccordion = function() {
	var $that = $(this);

	$that.each(function(i, el) {
		var $el = $(el);

		$el.on("hidden.bs.collapse", function() {
			var $h2 = $(this).prev("h2");
			$h2
				.find(">:first-child")
				.addClass("glyphicon-menu-right")
				.removeClass("glyphicon-menu-down");
			$h2.find("small").text("(click to expand)");
		});

		$el.on("shown.bs.collapse", function() {
			var $h2 = $(this).prev("h2");
			$h2
				.find(">:first-child")
				.removeClass("glyphicon-menu-right")
				.addClass("glyphicon-menu-down");
			$h2.find("small").text("(click to collapse)");
		});
	});
};

/**
 * REX element notification will show a bootstrap popover on the intended element.
 * @param {object} options - The object of configuration options.
 * @param {string} displayText - The text to display.
 */
$.fn.rexElementNotification = function(options, displayText) {

    var $that = $(this),
        settings = $.extend(
        {
            destroy: false,
            trigger: "manual",
            container: "body",
            content: displayText
        }, options);

    if (settings.destroy) {
        $that.popover("destroy");
        return;
    }

    if (!settings.content) {
        throw "You did not pass the option value for the notification content";
    }

    if (settings.className) {
        $that.popover(settings).popover("show").data("bs.popover").tip().addClass(settings.className);
    } else {
        $that.popover(settings).popover("show");
    }

};

/**
 * REX Tab Notification (telerik:RadTab only at this stage). No options will use defaults (preferred).
 * For example, <code>$("#someElement).rexTabNotification({ glyphicon: "glyphicon-ok" })</code> or
 * <code>$("#someElement).rexTabNotification({ destroy: true })</code>.
 * @param {Object} options The object of configuration options (Bootstrap popover settings).
 */
$.fn.rexTabNotification = function(options) {
	var $that = $(this);
	var $container = $that.find(".rtsOut");

	var settings = $.extend(
		{
			destroy: false,
			glyphicon: "glyphicon-exclamation-sign"
		},
		options
	);

	if (settings.destroy) {
		$container.removeClass("tabNotificationIndicator");
		$container.find("span.rtsTxt .glyphicon").remove();
		return;
	}

	if ($container.hasClass("tabNotificationIndicator")) {
		return;
	}

	$container.addClass("tabNotificationIndicator");
	var $el = $that.find("span.rtsTxt");
	$el.append("<span class='glyphicon " + settings.glyphicon + "'></span>");
};

//  execute plugins
var BackOffice = (function(backOffice, $) {

	var render = function() {
		//  configure all of these selectors as REX collapsibles
		$(".hybrid-filter-selects.panel-collapse").rexProductToggleAccordion();
	};

    backOffice.Module({
        name: "Plugins",
        init: function() {
            render();
        }
    });

	return $.extend(backOffice, {});
})(BackOffice || {}, jQuery);
